import React, { useEffect, useState } from 'react';

import Axios from 'axios';

import ConnectionCard from '@components/Connection/ConnectionCard';
import NwDrawer from '@components/Gui/NwDrawer';

import { Loading } from '@components/Gui/Loading';

const ConnectionDrawer = ({ connectionId, onClose }) => {
    const [connection, setConnection] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getConnection = async () => {
            setLoading(true);
            const connection = await Axios.get(`/connections/${connectionId}`);
            setConnection(connection);
            setLoading(false);
        };

        getConnection();

    }, []);

    return (
        <NwDrawer onClose={onClose} title="Connection">
            {loading ? (
                <Loading textBlack />
            ) : (
                connection && (
                    <div className="drawer-content standard">
                        <ConnectionCard readOnly item={connection} />
                    </div>
                )
            )}
        </NwDrawer>
    );
};

export default ConnectionDrawer;
